import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Edit = Styled(createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="white"
    stroke="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.83994 2.39982L3.36661 8.19315C3.15994 8.41315 2.95994 8.84649 2.91994 9.14649L2.67328 11.3065C2.58661 12.0865 3.14661 12.6198 3.91994 12.4865L6.06661 12.1198C6.36661 12.0665 6.78661 11.8465 6.99327 11.6198L12.4666 5.82649C13.4133 4.82649 13.8399 3.68649 12.3666 2.29315C10.8999 0.913152 9.78661 1.39982 8.83994 2.39982Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.92664 3.36621C8.2133 5.20621 9.70664 6.61288 11.56 6.79954"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 14.667H14"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Edit",
));

export default Edit;
